import { CONTACT_EVENT_STATE_MAP, LOG_PREFIX } from "../../constants/constants";
import { connectSession } from "../handlers/session";
import { changeAgentStateToAvailable } from "../handlers/agent";
import Emitter from "../../emitter";
import { API_CASE_REJECT, API_CASE_UPDATE, API_CONTACT_EVENT_LOGGING, CHANNEL_TYPES, TELEMETRY_ERROR, TELEMETRY_INFO } from "../constants";
import { updateTaskAndSend } from "../handlers/task";
const lp = LOG_PREFIX + "[api.task.ts]: ";

function getAgentContactById(id: string) {
  const logPrefix = lp + "getAgentContactById() " + id + " ";
  try {
    if (!connectSession.agent) {
      console.log(logPrefix + "Agent session not initialized");
      return null;
    }

    const contacts = connectSession.agent.getContacts(connect.ContactType.TASK);
    if (contacts && contacts.length > 0) {
      return contacts.find((ct: any) => ct.contactId === id);
    }
    return null;
  } catch (err) {
    console.log(logPrefix + "Error in getting contact by id", err);
    return null;
  }
}

export function acceptTaskContact(ev: any) {
  const logPrefix = lp + "acceptTaskContact() " + ev.body.conversationId;
  try {
    const taskContact = getAgentContactById(ev.body.conversationId);
    if (taskContact) {
      taskContact.accept({
        success: function () {
          console.log(
            logPrefix + "Task Accepted via Streams, taskContact = ",
            taskContact
          );
          // Update task state after successful acceptance
          updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ACCEPTED, taskContact);
        },
        failure: function (error: any) {
          console.log(
            logPrefix + "Failed to establish connection via Streams with error",
            error
          );
          // Only disconnect if acceptance failed
          disconnectTaskContact(ev);
        },
      });
    } else {
      console.log(logPrefix + "No Task contact found");
      clearCurrentTaskContact(ev.body.conversationId);
      updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {contactId: ev.body.conversationId});
    }
  } catch (e) {
    console.log(logPrefix + "Error in accepting task", e);
    clearCurrentTaskContact(ev.body.conversationId);
    updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, {contactId: ev.body.conversationId});
  }
}

export function disconnectTaskContact(ev: any, disconnectReason?: string) {
  const logPrefix = lp + "disconnectTaskContact " + ev.body.conversationId + " disconnectReason "+ disconnectReason;
  try {
    const taskContact = getAgentContactById(ev.body.conversationId);
    if (taskContact) {
      const taskAgentConn = taskContact.getAgentConnection();
      if (taskAgentConn) {
        taskAgentConn.destroy({
              success: function () {
                console.log(logPrefix + 'Task Disconnected via Streams');
                Emitter.emit(TELEMETRY_ERROR, {
                  type: "notif",
                  chan: TELEMETRY_INFO,
                  body: {
                    type: API_CASE_UPDATE,
                    info: logPrefix + "Disconnected via Streams with contact id: ",
                    message: logPrefix + ` Task Disconnected via Streams`,
                    disconnectReason: disconnectReason
                  },
                });
                taskContact.clear();
              },
              failure: function (err: any) {
                console.log(logPrefix + 'Error in task contact disconnect', err);
                clearCurrentTaskContact(ev.body.conversationId);
                updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev.body.conversationId });
                Emitter.emit(TELEMETRY_ERROR, {
                  type: "notif",
                  chan: TELEMETRY_ERROR,
                  body: {
                    type: API_CASE_UPDATE,
                    error: err,
                    info: logPrefix + ` Error in task contact disconnect`,
                    disconnectReason: disconnectReason,
                  },
                });
              }
            });
      } else {
        console.log(logPrefix + "No Task agent connection found");
        clearCurrentTaskContact(ev.body.conversationId);
        updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev.body.conversationId });
      }
    } else {
      console.log(logPrefix + "No Task contact found");
      clearCurrentTaskContact(ev.body.conversationId);
      updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev.body.conversationId });
    }
  } catch (error) {
    console.log(logPrefix + "Error in disconnecting task", error);
    clearCurrentTaskContact(ev.body.conversationId);
    updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev.body.conversationId });
  }
}

export function rejectTaskContact(ev: any) {
  const logPrefix = lp + "rejectTaskContact " + ev?.body?.conversationId;
  try {
    const contact = getAgentContactById(ev?.body?.conversationId);
    if (contact) {
      // Log the rejection event
      Emitter.emit(API_CONTACT_EVENT_LOGGING, {
        chan: API_CONTACT_EVENT_LOGGING,
        body: {
          contactId: contact?.contactId || contact?.getContactId(),
          eventType: CONTACT_EVENT_STATE_MAP.REJECTED,
          channel: CHANNEL_TYPES.TASK,
        },
      });
      changeAgentStateToAvailable();
      // Use contact.reject() to reject the incoming task
      contact.reject({
        success: function () {
          console.log(logPrefix + " Task rejected successfully");
          updateTaskAndSend(CONTACT_EVENT_STATE_MAP.REJECTED, { contactId: contact.contactId });
        },
        failure: function (err: any) {
          console.log(logPrefix + " Failed to reject task", err);
          Emitter.emit(TELEMETRY_ERROR, {
            type: "notif",
            chan: TELEMETRY_INFO,
            body: {
              type: API_CASE_REJECT,
              info: logPrefix + "rejected failed via Streams with contact id: ",
              message: logPrefix + ` Task rejected failed via Streams`,
              disconnectReason: 'Agent rejected the task'
            },
          });

          clearCurrentTaskContact(ev?.body?.conversationId);
          updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev?.body?.conversationId });
        }
      });
    } else {
      console.log(logPrefix + " No Task contact found");
      clearCurrentTaskContact(ev?.body?.conversationId);
      updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev?.body?.conversationId });
    }
  } catch (error) {
    console.log(logPrefix + " Error in rejecting task", error);
    clearCurrentTaskContact(ev?.body?.conversationId);
    updateTaskAndSend(CONTACT_EVENT_STATE_MAP.ENDED, { contactId: ev?.body?.conversationId });
  }
}

function updateTaskContact(ev: any) {
  if (ev.body.state === 'connected') {
    acceptTaskContact(ev);
  } else if (ev.body.state === 'disconnected') {
    disconnectTaskContact(ev, "Agent Disconnect");
  }
}
export function clearCurrentTaskContact(contactId: string) {
  const logPrefix = lp + "clearCurrentTaskContact " + contactId;
  try {
    const contact = getAgentContactById(contactId);
    if (contact) {
      try {
        // Check if contact is in a valid state before clearing
        const state = contact.getState();
        if (state && state.type !== 'error') {
          contact.clear();
        } else {
          console.log(logPrefix + " Contact is in error state, skipping clear");
        }
      } catch (clearError) {
        // If clear fails, it likely means the contact is already cleared
        console.log(logPrefix + " Contact already cleared or in invalid state");
      }
    } else {
      console.log(logPrefix + " No contact found to clear");
    }
  } catch (error) {
    console.log(logPrefix + " Error in clearing task contact", error);
  }
}

export default function registerTaskEvents() {
  Emitter.on(API_CASE_UPDATE, updateTaskContact);
  Emitter.on(API_CASE_REJECT, rejectTaskContact);
}